<template>
  <BaseListItem>
    <div class="flex -mx-4">
      <div class="w-64 px-4">
        <RouterLink :to="to">
          <template v-if="cover">
            <img
              v-if="cover"
              :srcset="cover.srcsets || ''"
              @load.once="onImageLoad"
              sizes="1px"
              :src="cover.url"
              class="block rounded w-full"
            />
          </template>
          <template v-else>
            <div class="aspect-ratio-16/9 w-full rounded bg-gray-200" />
          </template>
        </RouterLink>
      </div>
      <div class="flex-1 px-4">
        <RouterLink :to="to">
          {{ product.name }}
        </RouterLink>
        <p v-if="product.description">
          {{ product.description }}
        </p>
      </div>
    </div>
  </BaseListItem>
</template>

<script>
import mediableMixin from '@/mixins/mediableMixin';

const defaultProduct = {
  name: 'Product Name',
  description: 'Product Description',
  price: 0,
  requirements: null,
};

export default {
  name: 'PackageListItem',
  mixins: [mediableMixin],
  props: {
    entity: {
      type: Object,
      required: true,
    },
  },
  computed: {
    product() {
      return { ...defaultProduct, ...this.entity };
    },
    cover() {
      const { media = [] } = this.product || {};
      return media.find((item) => item.collection === 'images') || null;
    },
    to() {
      return {
        name: 'admin.products.packages.package',
        params: { packageId: this.entity.id },
      };
    },
  },
};
</script>
